import { useEffect, useState } from "react";
import { MdAddCard } from "react-icons/md";
import RolesDD from "./RolesDD.tsx";
import React from "react";
import { MdClose } from "react-icons/md";
import { DimensionFieldsModel } from "../../_core/_model.ts";
import { GetDimensionFields } from "../../_core/_request.ts";
import FieldCondition from "../Fields/FieldCondition.tsx";
import { AnimatePresence, motion } from "framer-motion";
import { FaSpinner } from "react-icons/fa6";
import { UserRequestRole } from "../Forms/UserRequest/_core/_models.ts";
import { Separators } from "../../Constants.ts";
import { Spinner } from "react-bootstrap";
import TooltipButton from "./TooltipButton.tsx";
import RoleDetailsOnTitle from "../Roles/RoleDetailsOnTitle.tsx";
import { FaInfoCircle } from "react-icons/fa";

interface request {
    showDropdown: boolean,
    initItems: UserRequestRole[],
    updateItems: (items: string[]) => void,
    dimensionCode: string
}
export function RoleItems({ showDropdown, initItems, updateItems, dimensionCode }: request) {
    const [items, setItems] = useState([""]);
    const [myFields, setMyFields] = useState<DimensionFieldsModel[]>([]);
    useEffect(() => {
        let rolIds = initItems?.map((x) => (x.roleID != null) ? (x.roleID > 0) ? x.roleID?.toString() : x.conditions : "");
        setItems(rolIds);
    }, [initItems])

    useEffect(() => {
        GetDimensionFields(dimensionCode).then((x) => {
            setMyFields(x.data);
        })
    }, [dimensionCode])

    const handleRemove = (index: number) => {
        const updated = items.filter((_, i) => i !== index);
        updateItems(updated);
    };

    const mIValid = (indx: number) => {
        let yes = false;
        if (typeof initItems[indx] != 'undefined') {
            if (showDropdown)
                yes = (initItems[indx].roleID != null && initItems[indx].roleID > 0);
            else
                yes = (!initItems[indx].conditions.isEmpty() && initItems[indx].conditions != "0" && !initItems[indx].conditions.split(Separators.column)[2].replace(/'/gi, "").isEmpty());
        }
        return yes;
    }

    return (
        myFields.length > 0 ?
            <div className="d-inline-flex gap-2 align-items-center flex-wrap">

                <AnimatePresence>
                    {items.map((p, indx) => (
                        <motion.div
                            key={indx}
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.95 }}
                            transition={{ duration: 0.2 }}
                            className={mIValid(indx) ? "item-container border bg-theme-card" : "item-container border-danger bg-theme-card"}
                        >
                            <div className="d-flex w-100 flex-row align-items-center gap-2">
                                {
                                    showDropdown ?
                                        <div style={{ flex: 1 }} className="d-flex flex-row align-items-center gap-1">
                                            <RolesDD dimensionCode={dimensionCode} skipItems={items.filter((x) => x != p)}
                                                initSelect={p}
                                                updateRole={(r) => {
                                                    let tItems = items;
                                                    tItems[indx] = r.toString();
                                                    updateItems([...tItems])
                                                }} />
                                            {
                                                !(p == null || p == "") &&
                                                <TooltipButton maxWidth={750} title={() =>
                                                    (p == null || p == "") ? (
                                                        null
                                                    ) : (
                                                        <RoleDetailsOnTitle roleId={p.toString()} />
                                                    )
                                                }>
                                                    <button
                                                        className="btn btn-outline-secondary rounded-3"
                                                    >
                                                        <FaInfoCircle
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                        />
                                                    </button>
                                                </TooltipButton>
                                            }
                                        </div> :
                                        <FieldCondition fields={myFields.filter((x) => x.forDirectUser == 1)}
                                            initValues={items[indx]}
                                            onChange={(v) => {
                                                let tItems = items;
                                                tItems[indx] = v;
                                                updateItems([...tItems])
                                            }} />
                                    // <input placeholder="Enter Product line description/number" className="item-input no-border" onChange={(e) => {
                                    //     let tItems = items;
                                    //     tItems[indx] = e.target.value.toString();
                                    //     updateItems([...tItems])
                                    // }} />
                                }
                                <button
                                    className="remove-btn rounded-3"
                                    onClick={() => handleRemove(indx)}
                                    title="Remove"
                                >
                                    <MdClose size={18} />
                                </button>
                            </div>
                            <AnimatePresence mode="wait">
                                {
                                    !mIValid(indx) && (
                                        <motion.span
                                            key="error"
                                            initial={{ opacity: 0, y: -5 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            exit={{ opacity: 0, y: -5 }}
                                            transition={{ duration: 0.25 }}
                                            className="badge text-bg-danger d-inline-flex align-items-center gap-1 px-2 py-1 mt-1"
                                        >
                                            <MdClose size={14} />
                                            {showDropdown ? "Role is required" : "Select a field and value for condition"}
                                        </motion.span>
                                    )
                                }
                            </AnimatePresence>
                        </motion.div>
                    ))
                    }
                </AnimatePresence>
                <button disabled={items.findIndex((x) => x.isEmpty()) > -1} className="bg-theme-card border-1 rounded-3 me-2 text-color" onClick={() => {
                    const newItem = showDropdown ? "-2" : "0";
                    updateItems([...items, newItem]);
                }}>
                    <div className="d-flex flex-row align-items-center gap-2">
                        <MdAddCard size={24} />
                        {
                            showDropdown ?
                                "Add more Role" :
                                "Add more conditions"
                        }
                    </div>
                </button>
                {/* Modern Styles */}
                <style>{`
        .item-container {
          display: flex;
          flex-direction: column;
          gap:4px;
          padding: 4px;
          min-width: 350px;
          border-radius: 6px;
          align-items: start;
        }
          @keyframes glow-red {
  0% { box-shadow: 0 0 0 rgba(220, 53, 69, 0.5); }
  50% { box-shadow: 0 0 8px rgba(220, 53, 69, 0.8); }
  100% { box-shadow: 0 0 0 rgba(220, 53, 69, 0.5); }
}

.item-container.border-danger {
  animation: glow-red 1.5s ease-in-out infinite;
}

        .item-input {
          flex: 1;
          border: none;
          outline: none;
          padding: 6px 10px;
          font-size: 14px;
          background-color: transparent;
        }

        .remove-btn {
          background-color: #f8d7da;
          border: none;
          color: #dc3545;
          padding:7px;
          width: 36px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border-left: 1px solid #ccc;
          transition: all 0.2s ease;
        }

        .remove-btn:hover {
          background-color: #dc3545;
          color: white;
          transform: scale(1.05);
        }
      `}</style>
            </div> :
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="d-flex align-items-center gap-2 p-3 border rounded bg-card"
            >
                <Spinner size="sm" />
                <span className="text-muted-theme">Loading...</span>
            </motion.div>
    )
}

export default RoleItems;